import { NgModule } from '@angular/core';
import { SpinnerComponent } from './spinner.component';

@NgModule({
  exports: [
    SpinnerComponent
  ],
  declarations: [
    SpinnerComponent
  ]
})

export class SpinnerModule { }
